import { USER_PROFILE_API } from '../constants/AppConstants';

// #genai
/**
 * Service to fetch user profile
 * @returns {Promise} - API response promise
 */
const getUserProfile = async () => {
  try {
    const response = await fetch(USER_PROFILE_API);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};

export default getUserProfile;
